import React from "react";

import Banner from "../../../assets/images/backgrounds/banner-seguro-empresarial-desktop.png";
import BannerMobile from "../../../assets/images/backgrounds/banner-seguro-empresarial-mobile.png";
import HeroSection from "../../../components/Habitacional/HeroSection";
import AdvantagesSection from "../Sections/AdvantagesSection/AdvantagesSection";
import CoverageSection from "../../../components/common/CoverageSection/CoverageSection";
import AssistanceServiceSection from "../Sections/AssistanceServiceSection/AssistanceServiceSection";
import HireSection from "../Sections/HireSection/HireSection";
import ActivateInsuranceSection from "../Sections/ActivateInsuranceSection/ActivateInsuranceSection";
import FaqSection from "../Sections/FaqSection/FaqSection";
import DocumentsSection from "../Sections/DocumentsSection/DocumentsSection";

import {
  InsuranceAdvantageList,
  InsuranceCoverageList,
  InsuranceDocumentList,
  InsurancefaqList,
} from "../Constants/BusinessInsurance.constants";

export const BusinessInsurance = () => {
  return (
    <>
      <HeroSection
        backgroundImageDesktop={Banner}
        backgroundImageMobile={BannerMobile}
        primarySubtitle="Seguro"
        mainTitle={
          <>
            Fácil Empresarial <br /> Empreendedor
          </>
        }
      />
      <AdvantagesSection advantagesList={InsuranceAdvantageList} />
      <CoverageSection
        textsList={[
          {
            id: "1-text",
            title: "Segurança financeira acessível para a sua empresa",
            description: (
              <>
                Se você tem um pequeno negócio, como uma banca de rua, uma
                barraca de comida, ou trabalha com costura, beleza ou artesanato
                — seja em casa, em uma loja ou ao ar livre — o{" "}
                <strong>Seguro Fácil Empresarial Empreendedor</strong> é a
                escolha ideal para a sua realidade. Com parcelas que cabem no
                seu bolso e vigência de três anos, ele oferece a segurança
                financeira necessária para você seguir em frente, com
                tranquilidade, mesmo diante de situações inesperadas como
                incêndios, roubos de equipamentos ou perda de matéria-prima.
              </>
            ),
          },
          {
            id: "2-text",
            title: "Coberturas",
            description: (
              <>
                Com o <strong>Seguro Fácil Empresarial Empreendedor</strong>,
                garantimos a segurança do seu negócio nas seguintes{" "}
                <strong>situações inesperadas</strong>:
              </>
            ),
          },
        ]}
        coverageList={InsuranceCoverageList}
      />
      <AssistanceServiceSection serviceName="Seguro Fácil Empresarial Empreendedor" />
      <HireSection />
      <ActivateInsuranceSection />
      <FaqSection
        faqTitle="Fácil Empresarial Empreendedor"
        faqList={InsurancefaqList}
      />
      <DocumentsSection
        documentType="Seguro Fácil Empresarial Empreendedor"
        documentList={InsuranceDocumentList}
      />
    </>
  );
};
